import React, { createContext, useContext } from "react";
import rootStore, { RootStore } from "./RootStore";

const StoreContext = createContext<RootStore | null>(null);

export const StoreProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <StoreContext.Provider value={rootStore}>{children}</StoreContext.Provider>
  );
};

export const useStore = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error("useStore must be used within a StoreProvider");
  }
  return context;
};

export const useCourtBookingStore = () => {
  const { courtBookingStore } = useStore();
  return courtBookingStore;
};
export const useSectionStore = () => {
  const { sectionStore } = useStore();
  return sectionStore;
};

export const useSelectCircleStore = () => {
  const { selectCircleStore } = useStore();
  return selectCircleStore;
};

export const usePaymentStore = () => {
  const { payemntStore } = useStore();
  return payemntStore;
};

export const useUserStore = () => {
  const { userStore } = useStore();
  return userStore;
};

export const useLoginStore = () => {
  const { loginStore } = useStore();
  return loginStore;
};

export const useOTPStore = () => {
  const { otpStore } = useStore();
  return otpStore;
};

export const useMatchListStore = () => {
  const { matchListStore } = useStore();
  return matchListStore;
};

export const useMatchDetailsStore = () => {
  const { matchDetailsStore } = useStore();
  return matchDetailsStore;
};

export const useMatchStatsStore = () => {
  const { matchStatsStore } = useStore();
  return matchStatsStore;
};
